import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { deleteProfileValidationSchema } from "../ValidationSchema";
import {
  deleteProfile,
  fetchProfileStatus,
  getDeleteReason,
  privacySetting,
  privacySettingShow,
  toggleProfileVisibility,
} from "../../asiosConfig";

import Popup from "../Popup";

import {
  getPrivacySettings,
  submitPrivacySettings,
} from "../../javaAxiosConfig";

import { toast } from "react-toastify";

/* ===== FIGMA ASSETS ===== */
import accountsettingDesign from "../../images/accountsettingDesign.png";
import privacyIcon from "../../images/privacySetting.png";
import deleteHideIcon from "../../images/deleteHideAccount.png";

import lightArrowRight from "../../images/arrow-leftBack.svg";

import StarIcon from "../../images/Star.png";

export const Setting = () => {
  const navigate = useNavigate();

  const [privacyData, setPrivacyData] = useState([]);
  const [initialPrivacyData, setInitialPrivacyData] = useState(null);
  const [activeModal, setActiveModal] = useState(null);
  const FIXED_PERCENT = 70;

  const [isSaving, setIsSaving] = useState(false);
  const [initialSettings, setInitialSettings] = useState(null);

  const [popup, setPopup] = useState({
  open: false,
  type: "success",
  title: "",
  message: "",
});

  /* ================= VIEW STATE ================= */
  const [activeView, setActiveView] = useState("MAIN");
  // MAIN | PRIVACY | HIDE_DELETE

  /* ================= DATA STATE ================= */
  const [deleteReason, setDeleteReason] = useState([]);
  const [profileVisibility, setProfileVisibility] = useState(0);

  const [settings, setSettings] = useState({
    contact_setting: 1,
    send_interest_setting: 1,
    chatting_setting: 1,
    photo_privacy_setting: 1,
  });

  // ✅ Check if user changed anything
const isDirty =
  initialPrivacyData &&
  JSON.stringify(privacyData) !== JSON.stringify(initialPrivacyData);

  const InnerHeader = ({ title, subtitle }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginBottom: 30,
      }}
    >
      {/* Back Arrow */}
      <img
        src={lightArrowRight}
        alt="back"
        style={{
          width: 25,
          height: 25,
          cursor: "pointer",
          // transform: "rotate(180deg)",
        }}
        onClick={() => setActiveView("MAIN")}
      />

      {/* Heading + Subheading */}
      <div>
        <h3
          style={{
            margin: 0,
            fontWeight: 600,
            textAlign: "left",
            fontSize: 20,
          }}
        >
          {title}
        </h3>
        <p style={{ margin: "4px 0 4px", color: "#777", fontSize: 15 }}>
          {subtitle}
        </p>
      </div>
    </div>
  );

  const mapPrivacyDataToSettings = (data) => {
    const mapped = {};

    data.forEach((section) => {
      const selectedIndex = section.options.findIndex(
        (opt) => opt.value === true
      );

      if (selectedIndex === -1) return;

      const uiValue = selectedIndex + 1; // UI uses 1-based index

      if (section.type === "CONTACT") {
        mapped.contact_setting = uiValue;
      }

      if (section.type === "CHAT") {
        mapped.chatting_setting = uiValue;
      }

      if (section.type === "INTEREST") {
        mapped.send_interest_setting = uiValue;
      }
    });

    return mapped;
  };

  useEffect(() => {
    const init = async () => {
      try {
        // Existing privacy settings (PHP)
        //   const privacyRes = await privacySettingShow();
        //   if (privacyRes.status === 200 || privacyRes.status === 201) {
        //     setSettings(privacyRes.data.data || settings);
        //   }

        // Delete reasons
        const deleteRes = await getDeleteReason();
        if (deleteRes.status === 200 || deleteRes.status === 201) {
          setDeleteReason(deleteRes.data);
        }

        // Profile visibility
        const visibilityRes = await fetchProfileStatus();
        if (visibilityRes.status === 200 || visibilityRes.status === 201) {
          setProfileVisibility(visibilityRes.data.data.hideProfile);
        }

        // ✅ Java privacy settings (for matching criteria modal)
        // const privacyJavaRes = await getPrivacySettings();
        // setPrivacyData(privacyJavaRes?.data || []);

        const privacyJavaRes = await getPrivacySettings();
        const apiData = privacyJavaRes?.data || [];

        setPrivacyData(apiData);

        setInitialPrivacyData(JSON.parse(JSON.stringify(apiData)));

        // 🔥 SYNC API → UI BUTTON STATE
        const mappedSettings = mapPrivacyDataToSettings(apiData);

        console.group("[PRIVACY INIT]");
        console.log("API privacyData:", apiData);
        console.log("Mapped UI settings:", mappedSettings);
        console.groupEnd();

        setSettings((prev) => {
  const updated = {
    ...prev,
    ...mappedSettings,
  };

  // ✅ store initial snapshot for dirty check
  setInitialSettings(updated);

  return updated;
});
      } catch (error) {
  console.error("Settings init error:", error);

  setPopup({
    open: true,
    type: "error",
    title: "Error",
    message: "Failed to load settings",
  });
}
    };

    init();
  }, []);

  /* ================= HANDLERS ================= */
  const handleChange = (name, value) => {
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  // const handleSave = async () => {
  //   try {
  //     await submitPrivacySettings(privacyData);
  //     toast.success("Privacy settings updated successfully");
  //   } catch {
  //     toast.error("Failed to update privacy settings");
  //   }
  // };

  


const handleSave = async () => {
  try {
    setIsSaving(true);

    const res = await submitPrivacySettings(privacyData);

    if (res?.data?.status === true) {
      setPopup({
        open: true,
        type: "success",
        title: "Success",
        message:
          res?.data?.message ||
          "Privacy settings updated successfully",
      });

      // reset dirty state
      setInitialPrivacyData(
        JSON.parse(JSON.stringify(privacyData))
      );
    } else {
      setPopup({
        open: true,
        type: "error",
        title: "Error",
        message:
          res?.data?.message ||
          "Something went wrong while saving",
      });
    }
  } catch (error) {
    console.error("Save error:", error);

    setPopup({
      open: true,
      type: "error",
      title: "Error",
      message: "Failed to update privacy settings",
    });
  } finally {
    setIsSaving(false);
  }
};

  const updatePrivacyDataSelection = (type, selectedOptionName) => {
  setPrivacyData((prev) =>
    prev.map((section) => {
      if (section.type !== type) return section;

      return {
        ...section,
        options: section.options.map((opt) => ({
          ...opt,
          value: opt.name === selectedOptionName,
        })),
      };
    })
  );
};


  const handleToggleVisibility = async () => {
    const res = await toggleProfileVisibility({
      status: profileVisibility === 0 ? 1 : 0,
    });
    // if (res.status === 200 || res.status === 201) {
    //   setProfileVisibility(res.data.data);
    //   toast.success(
    //     res.data.data === 1 ? "Profile Hidden" : "Profile Unhidden"
    //   );
    // }

    if (res.status === 200 || res.status === 201) {
  setProfileVisibility(res.data.data);

  setPopup({
    open: true,
    type: "success",
    title: "Success",
    message:
      res.data.data === 1
        ? "Profile Hidden Successfully"
        : "Profile Unhidden Successfully",
  });
}
  };

  const toggleStrictMatching = (sIndex, oIndex, mIndex) => {
    setPrivacyData((prev) =>
      prev.map((section, si) =>
        si !== sIndex
          ? section
          : {
              ...section,
              options: section.options.map((opt, oi) =>
                oi !== oIndex
                  ? opt
                  : {
                      ...opt,
                      strict_matching: opt.strict_matching.map((m, mi) =>
                        mi === mIndex ? { ...m, value: !m.value } : m
                      ),
                    }
              ),
            }
      )
    );
  };

  /* ================= DELETE FORM ================= */
  const deleteFormik = useFormik({
    initialValues: { delete_reason: "" },
    validationSchema: deleteProfileValidationSchema,
    onSubmit: async (values) => {
      const res = await deleteProfile(values);
      // if (res.status === 200 || res.status === 201) {
      //   toast.success("Profile Deleted Successfully");
      //   localStorage.removeItem("token");
      //   navigate("/");
      // }

      if (res.status === 200 || res.status === 201) {
  setPopup({
    open: true,
    type: "success",
    title: "Success",
    message: "Profile Deleted Successfully",
  });

  setTimeout(() => {
    localStorage.removeItem("token");
    navigate("/");
  }, 1000);
}
    },
  });

  /* ================= UI HELPERS ================= */
  const renderOptions = (title, name, options) => (
    <div style={{ marginBottom: 30 }}>
      <p style={{ fontWeight: 600, textAlign: "left" }}>{title}</p>
      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
        {options.map((label, i) => {
          const value = i + 1;
          const active = settings[name] === value;
          return (
            <div
              key={value}
             
              // onClick={() => {
              //   handleChange(name, value);

              //   if (label === "Only Member who match my criteria") {
              //     const sectionIndex = privacyData.findIndex(
              //       (s) =>
              //         (name === "contact_setting" && s.type === "CONTACT") ||
              //         (name === "chatting_setting" && s.type === "CHAT") ||
              //         (name === "send_interest_setting" &&
              //           s.type === "INTEREST")
              //     );

              //     if (sectionIndex !== -1) {
              //       const optionIndex = privacyData[
              //         sectionIndex
              //       ].options.findIndex((o) => o.name === "MATCHING_CRITERIA");

              //       if (optionIndex !== -1) {
              //         setActiveModal({
              //           sIndex: sectionIndex,
              //           oIndex: optionIndex,
              //         });
              //       }
              //     }
              //   }
              // }}

              onClick={() => {
  handleChange(name, value);

  const sectionType =
    name === "contact_setting"
      ? "CONTACT"
      : name === "chatting_setting"
      ? "CHAT"
      : "INTEREST";

  const optionName =
    label === "Anyone"
      ? "ANYONE"
      : label === "Only Member who match my criteria"
      ? "MATCHING_CRITERIA"
      : "INTEREST_SENT_ACCEPTED";

  // 🔥 SYNC PAYLOAD
  updatePrivacyDataSelection(sectionType, optionName);

  // Open modal ONLY for matching criteria
  if (optionName === "MATCHING_CRITERIA") {
    const sectionIndex = privacyData.findIndex(
      (s) => s.type === sectionType
    );

    if (sectionIndex !== -1) {
      const optionIndex = privacyData[sectionIndex].options.findIndex(
        (o) => o.name === "MATCHING_CRITERIA"
      );

      if (optionIndex !== -1) {
        setActiveModal({ sIndex: sectionIndex, oIndex: optionIndex });
      }
    }
  }
}}


              style={{
                padding: "10px 20px",
                borderRadius: 30,
                border: active ? "1px solid #ff3c3c" : "1px solid #ccc",
                color: active ? "#ff3c3c" : "#555",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );

  /* ================= RENDER ================= */
  return (
    <div className="col-lg-9 col-12">
      {/* ===== PAGE HEADER (OUTSIDE CARD) ===== */}
      <h5 style={{ textAlign: "left", marginBottom: 10, fontWeight: "600" }}>
        Account Settings
      </h5>

      {/* <div style={{ textAlign: "center", marginBottom: 25 }}>
        <img src={StarIcon} alt="" />
      </div> */}

      <Card sx={{ borderRadius: 3, p: 4, boxShadow: "0px 0px 0px"}}>
        {/* ================= MAIN ================= */}
        {activeView === "MAIN" && (
          <>
            <h5
              style={{
                textAlign: "center",
                marginBottom: 10,
                marginTop: 10,
                fontWeight: "600",
              }}
            >
              Adjust profile visibility, security, and more.{" "}
            </h5>
            <img
              src={accountsettingDesign}
              alt=""
              style={{
                display: "block",
                margin: "20px auto 40px",
                width: "25%",
              }}
            />

            <div style={cardStyle} onClick={() => setActiveView("PRIVACY")}>
              <div style={{ display: "flex" }}>
                <img
                  src={privacyIcon}
                  style={{
                    display: "flex",
                    width: 40,
                    height: 40,
                    justifyContent: "center",
                  }}
                />
                <div style={{ textAlign: "left", marginLeft: 20 }}>
                  <h5>Privacy Settings</h5>
                  <p>Control who can see your details and contact you.</p>
                </div>
              </div>

              {/* <Button variant="outlined">Manage</Button> */}

              <div
                style={{
                  height: "40px",
                  padding: "0 24px",
                  borderRadius: "50px",
                  backgroundColor: "#fff",
                  border: "1px solid #e9e9e9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#000",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Manage
              </div>
            </div>

            <div style={cardStyle} onClick={() => setActiveView("HIDE_DELETE")}>
              <div style={{ display: "flex" }}>
                <img
                  src={deleteHideIcon}
                  style={{
                    display: "flex",
                    width: 40,
                    height: 40,
                    justifyContent: "center",
                  }}
                />
                <div>
                  <div style={{ textAlign: "left", marginLeft: 20 }}>
                    <h5>Hide/Delete Profile</h5>
                    <p>Temporarily hide or permanently delete your profile.</p>
                  </div>
                </div>
              </div>

              {/* <Button variant="outlined">Edit Status</Button> */}

              <div
                style={{
                  height: "40px",
                  padding: "0 24px",
                  borderRadius: "50px",
                  backgroundColor: "#fff",
                  border: "1px solid #e9e9e9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#000",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Edit Status
              </div>
            </div>
          </>
        )}

        {/* ================= PRIVACY ================= */}
        {activeView === "PRIVACY" && (
          <>
            {/* <h3>Privacy Settings</h3>
            <p>Control who can see your details and contact you.</p> */}

            <InnerHeader
              title="Privacy Settings"
              subtitle="Control who can see your details and contact you."
            />

            {renderOptions("Who Can Contact Me", "contact_setting", [
              "Anyone",
              "Only Member who match my criteria",
              "Only to interest sent/accepted",
            ])}

            {/* Divider */}
            <div
              style={{
                height: "1px",
                backgroundColor: "#e5e5e5",
                margin: "24px 0",
                width: "100%",
              }}
            />

            {renderOptions("Who Can Send Interest", "send_interest_setting", [
              "Anyone",
              "Only Member who match my criteria",
            ])}

            {/* Divider */}
            <div
              style={{
                height: "1px",
                backgroundColor: "#e5e5e5",
                margin: "24px 0",
                width: "100%",
              }}
            />

            {renderOptions("Who Can Chat with me", "chatting_setting", [
              "Anyone",
              "Only Member who match my criteria",
              "Only to interest sent/accepted",
            ])}

            <div style={{ textAlign: "center" }}>
             <Button
  onClick={handleSave}
  disabled={!isDirty || isSaving}
  sx={{
    width: "25%",
    background:
      isDirty
        ? "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))"
        : "#ccc",
    color: "#fff",
    borderRadius: 30,
    px: 6,
    fontSize: "15px",
    fontWeight: "600",
    fontFamily: "Montserrat",
    opacity: !isDirty ? 0.7 : 1,
    cursor: !isDirty ? "not-allowed" : "pointer",
  }}
>
  {isSaving ? "Saving..." : "Save"}
</Button>
            </div>
          </>
        )}

        {/* ================= HIDE / DELETE ================= */}
        {activeView === "HIDE_DELETE" && (
          <>
            <InnerHeader
              title="Hide/Delete Profile"
              subtitle="Temporarily hide or permanently delete your profile."
            />

            <div style={{ display: "flex" }}>
              {/* <img
                src={StarIcon}
                style={{
                  display: "flex",
                  width: 25,
                  height: 25,
                  justifyContent: "center",
                }}
              /> */}

              <div style={{ textAlign: "left" }}>
                <h5>Hide Profile</h5>
                <p style={{ margin: "4px 0 0", color: "#777", fontSize: 15 }}>
                  You can view profiles but won't be able to send interests or
                  messages, and your profile will not be shown to others.
                </p>
              </div>
            </div>

            <div
              onClick={handleToggleVisibility}
              style={{
                height: "40px",
                width: "200px",
                borderRadius: "50px",
                backgroundColor: "rgba(255, 255, 255, 0.12)",
                border: "1px solid #000",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "15px",
                fontWeight: 500,
                color: "#000",
                cursor: "pointer",
                userSelect: "none",
                marginTop: "20px",
              }}
            >
              {profileVisibility === 0 ? "Hide Profile" : "Unhide Profile"}
            </div>

            <hr style={{ margin: "40px 0" }} />

            <div style={{ textAlign: "left", marginBottom: 20 }}>
              <h5>Delete Profile</h5>
              <p style={{ margin: "4px 0 0", color: "#777", fontSize: 15 }}>
                You can view profiles but won't be able to send interests or
                messages, and your profile will not be shown to others.
              </p>
            </div>
            <form onSubmit={deleteFormik.handleSubmit}>
              <RadioGroup
                name="delete_reason"
                style={{ fontFamily: "Montserrat" }}
                value={deleteFormik.values.delete_reason}
                onChange={deleteFormik.handleChange}
              >
                {deleteReason.map((r) => (
                  <FormControlLabel
                    key={r.id}
                    value={r.id}
                    control={<Radio />}
                    label={r.Delete_reason}
                    style={{ fontFamily: "Montserrat" }}
                  />
                ))}
              </RadioGroup>

              <div
                onClick={deleteFormik.handleSubmit}
                style={{
                  height: "45px",
                  width: "25%",
                  borderRadius: "100px",
                  background:
                    "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "14px 34px",
                  fontSize: "15px",
                  fontWeight: 600,
                  fontFamily: "Montserrat",
                  color: "#fff",
                  cursor: "pointer",
                  marginTop: "24px",
                  userSelect: "none",
                }}
              >
                Delete Profile
              </div>
            </form>
          </>
        )}
      </Card>

      {activeModal && (
        <div style={overlay}>
          <div style={modal}>
           <div style={closeBtn} onClick={() => setActiveModal(null)}>
  <span
    style={{
      fontSize: 16,
      fontWeight: 700,
      color: "#000",
      lineHeight: 1,
    }}
  >
    ✕
  </span>
</div>

            <div style={modalHeader}>
              <div style={{ fontSize: 16, fontWeight: 700 }}>
                Preference
              </div>
              <div style={percentCircle}>{FIXED_PERCENT}%</div>
            </div>

            {privacyData[activeModal.sIndex].options[
              activeModal.oIndex
            ].strict_matching.map((item, i) => (
              <React.Fragment key={item.name}>
                <div style={row}>
                  <span style={{ fontWeight: 600 }}>
                    {item.name.replace(/_/g, " ").toLowerCase()}
                  </span>

                  <div
                    onClick={() =>
                      toggleStrictMatching(
                        activeModal.sIndex,
                        activeModal.oIndex,
                        i
                      )
                    }
                    style={{
                      ...switchBox,
                      ...(item.value ? switchOn : {}),
                    }}
                  >
                    <div
                      style={{
                        ...switchKnob,
                        ...(item.value ? knobOn : {}),
                      }}
                    />
                  </div>
                </div>

                {i !==
                  privacyData[activeModal.sIndex].options[activeModal.oIndex]
                    .strict_matching.length -
                    1 && <div style={divider} />}
              </React.Fragment>
            ))}

            <div style={saveBtn} onClick={() => setActiveModal(null)}>
              Save Preferences
            </div>
          </div>
        </div>
      )}

      <Popup
  open={popup.open}
  type={popup.type}
  title={popup.title}
  message={popup.message}
  onClose={() =>
    setPopup((prev) => ({ ...prev, open: false }))
  }
/>
    
    </div>
  );
};

/* ================= STYLES ================= */
const cardStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 20,
  padding: 20,
  borderRadius: 12,
  background: "#fff",
  boxShadow: "2px 2px 25px -6px rgba(0,0,0,0.15)",
  cursor: "pointer",
  marginBottom: 20,
};

/* ===== MODAL ===== */

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1500,
};

const modal = {
  background: "#fff",
  width: "90%",
  maxWidth: 420,
  borderRadius: 20,
  padding: 30,
  position: "relative",
};

const closeBtn = {
  position: "absolute",
  top: 14,
  right: 14,
  width: 35,
  height: 35,
  borderRadius: "50%",
  backgroundColor: "#fff",
  border: "1px solid #fff0ed",
  boxShadow: "0px 4px 4px #fff0ed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxSizing: "border-box",
};

const modalHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  // margin: 2,
  paddingRight: 40,
};

const percentCircle = {
  width: 46,
  height: 44,
  borderRadius: "50%",
  background: "#FFF1F1",
  border: "1px solid #FFDCDC",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  color: "rgba(222, 64, 64, 0.81)",
};

const row = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "14px 0",
};

const divider = {
  height: 1,
  background: "#E0E0E0",
};

const switchBox = {
  width: 38,
  height: 20,
  borderRadius: 20,
  background: "#CCC",
  position: "relative",
  cursor: "pointer",
};

const switchOn = {
  background: "rgba(230,0,0,0.81)",
};

const switchKnob = {
  width: 16,
  height: 16,
  background: "#FFF",
  borderRadius: "50%",
  position: "absolute",
  top: 2,
  left: 2,
  transition: "0.2s",
};

const knobOn = {
  left: 20,
};

const saveBtn = {
  marginTop: 16,
  background:
    "linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(180deg, rgba(255, 119, 5, 0.88), rgba(230, 0, 0, 0.81))",
  color: "#fff",
  textAlign: "center",
  padding: 12,
  borderRadius: 50,
  fontWeight: 700,
  cursor: "pointer",
};

const modalInfo = {
  marginTop: 12,
  fontSize: 12,
  color: "#666",
  textAlign: "center",
  width: "100%",
  padding: 10,
  border: "1px dashed rgba(230,0,0,0.5)",
  borderRadius: 12,
  fontSize: 12,
};
